"use strict";
const angular = require("angular");

import uiRouter from "angular-ui-router";

import { requestConfigV2 } from "../company.component";
import routes from "./companygenie.routes";
/**
 * @class angular_module.CompanyGenieComponent
 */
export class CompanyGenieComponent {
  /*@ngInject*/
  constructor($http, $scope, $uibModal, Modal, CompanyService, $location, $timeout) {
    this.$http = $http;
    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.CompanyService = CompanyService;
    this.$location = $location;
    this.$timeout = $timeout;
    this.company_name = "";
    this.isCompanyNameEditMode = false;
    this.company = "";
    this.startDate = new Date();
    this.endDate = new Date();
    this.gamesAvailable = "";
    this.success = false;
    this.error = false;
    this.isActive = null;
    this.offlineScorm = false;
    this.certificateScreenText = "";
    this.instructionScreenGameDuration = null;
    this.otpEnabled = false;
    this.passPercentage = null;
    this.emailDomain = "";
    this.enableTranslation = false;

    // Background list state
    this.backgroundsList = [];
    this.backgroundsLoading = false;
    this.backgroundsLoaded = false;

    // Screens dropdown state
    this.screensSearchTerm = "";
    this.screensFiltered = [];
    this.screensDisplayLimit = 50;
    this.selectedScreen = null;

    // Logos dropdown state
    this.logosSearchTerm = "";
    this.logosFiltered = [];
    this.logosDisplayLimit = 50;
    this.selectedLogo = null;

    // Debounce timers
    this.screensDebounceTimer = null;
    this.logosDebounceTimer = null;

    // Selection state for inline UI
    this.selection = {
      screenId: null,
      screenName: null,
      desktopPreview: null,
      mobilePreview: null,
      desktopUrl: null,
      mobileUrl: null,
      logoId: null,
      logoName: null,
      logoDesktopPreview: null,
      logoMobilePreview: null,
      logoDesktopUrl: null,
      logoMobileUrl: null,
    };
    this.selectionError = false;
    this.selectionErrorMessage = null;
    this.saving = false;

    // Dropdown open state
    this.screensDropdownOpen = false;
    this.logosDropdownOpen = false;

    // Preview modal state
    this.showPreviewModal = false;
    this.previewTitle = "";
    this.previewDesktopUrl = null;
    this.previewMobileUrl = null;
  }

  /**
   * @function $onInit
   * @memberOf angular_module.CompFrameworkComponent
   * @fires getCompframeworks
   * @description this function intiates the CompFramework Component.
   */
  $onInit() {
    this.getCompany();
  }

  getCompany() {
    this.$http.get("/api/company/" + sessionStorage.company_id).then(
      (res) => {
        this.company = res.data;
        this.startDate = new Date(this.company.genieSubscription?.startDate);
        this.endDate = new Date(this.company.genieSubscription?.endDate);
        this.gamesAvailable = this.company.genieSubscription?.gamesAvailable;
        this.isActive = this.company.genieSubscription?.status === "active";
        this.offlineScorm = this.company.offlineScorm;
        this.certificateScreenText = this.company.genieSubscription?.certificateScreen?.text?.original || this.company.genieSubscription?.certificateScreen?.text || "This is to certify that @firstname has completed the E-Learning module @journeyname.";
        this.instructionScreenGameDuration = this.company.genieSubscription?.instructionScreen?.gameDuration || null;
        this.otpEnabled = this.company.genieSubscription?.otpEnabled || false;
        this.passPercentage = this.company.genieSubscription?.passPercentage ?? null;
        this.emailDomain = this.company.emailDomain || "";
        this.enableTranslation = this.company.enableTranslation || false;

        // Pre-fill selections from existing company data
        this.prefillSelectionsFromCompany();
        
        // Load backgrounds list
        this.loadBackgroundsList();
      },
      (err) => {
        this.$location.path("/company");
      }
    );
  }

  updateCompany(company) {
    return this.$http.put(`/api/company/${company._id}`, company);
  }

  confirmDate() {
    this.company["genieSubscription"] = {
      usage: this.company.genieSubscription?.usage,
    };

    this.company["genieSubscription"] = {
      ...this.company.genieSubscription,
      startDate: this.startDate,
    };
    this.company["genieSubscription"] = {
      ...this.company.genieSubscription,
      endDate: this.endDate,
    };
    this.company["genieSubscription"] = {
      ...this.company.genieSubscription,
      gamesAvailable: this.gamesAvailable,
    };

    this.company["genieSubscription"] = {
      ...this.company.genieSubscription,
      status: this.isActive ? "active" : "inactive",
    };

    this.company["genieSubscription"] = {
      ...this.company.genieSubscription,
      otpEnabled: this.otpEnabled,
    };

    // Validate passPercentage: must be 0-100
    let validPassPercentage;
    if (this.passPercentage !== null && this.passPercentage !== '') {
      const numVal = Number(this.passPercentage);
      if (isNaN(numVal) || numVal < 0 || numVal > 100) {
        this.error = true;
        this.passPercentageError = "Pass Percentage must be between 0 and 100";
        setTimeout(() => {
          this.error = null;
          this.passPercentageError = null;
        }, 3000);
        return; // Block submission
      }
      validPassPercentage = numVal;
    }
    this.passPercentageError = null;

    this.company["genieSubscription"] = {
      ...this.company.genieSubscription,
      passPercentage: validPassPercentage,
    };

    // Build brands payload if selections exist
    let brandsPayload = [];
    if (this.selection.screenId || this.selection.logoId) {
      const brand = {};
      if (this.selection.screenId) {
        brand.screens = [{
          screenId: this.selection.screenId,
          name: this.selection.screenName,
          url: this.selection.desktopUrl,
          iosUrl: this.selection.mobileUrl,
        }];
      }
      if (this.selection.logoId) {
        brand.logos = [{
          logoId: this.selection.logoId,
          name: this.selection.logoName,
          url: this.selection.logoDesktopUrl,
          iosUrl: this.selection.logoMobileUrl,
        }];
      }
      brandsPayload = [brand];
    }

    // Build v2 payload
    const v2GenieSubscription = {
      ...this.company.genieSubscription,
      certificateScreen: { text: this.certificateScreenText },
      instructionScreen: { gameDuration: Number(this.instructionScreenGameDuration) || null },
      otpEnabled: this.otpEnabled,
      passPercentage: validPassPercentage,
    };

    const reqConfig = requestConfigV2("EDIT", {
      _id: this.company._id,
      genieSubscription: v2GenieSubscription,
      brands: brandsPayload,
      emailDomain: this.emailDomain,
    });

    const updatedCompany = {
      ...this.company,
      offlineScorm: this.offlineScorm,
      brands: brandsPayload,
      emailDomain: this.emailDomain,
      enableTranslation: this.enableTranslation,
    };

    this.saving = true;
    this.success = false;
    this.error = false;
    this.errorMessage = null;

    this.updateCompany(updatedCompany)
      .then(() => {
        return this.$http(reqConfig);
      })
      .then((compData) => {
        this.success = true;
        this.saving = false;
        this.getCompany(); // Only refresh after v2 update completes
        console.log("Updated in v2", compData);
        
        // Clear success message after delay
        setTimeout(() => {
          this.success = null;
        }, 3000);
      })
      .catch((err) => {
        console.error("Update failed", err);
        this.error = true;
        this.errorMessage = this.extractErrorMessage(err);
        this.saving = false;
      });
  }

  extractErrorMessage(err) {
    if (!err) return "Error performing operation";

    if (err.data && (err.data.message || err.data.error))
      return err.data.message || err.data.error;
    if (err.data && typeof err.data === "string") return err.data;
    if (err.statusText) return err.statusText;
    if (err.message) return err.message;
    return "Error performing operation";
  }

  loadBackgroundsList() {
    if (this.backgroundsLoaded || this.backgroundsLoading) return;

    this.backgroundsLoading = true;
    const reqConfig = requestConfigV2("GET", null, "backgrounds/list", 2);

    this.$http(reqConfig)
      .then((resp) => {
        this.backgroundsList = resp.data.list || [];
        this.backgroundsLoaded = true;
        this.backgroundsLoading = false;
        // Initialize filtered lists
        this.filterScreens();
        this.filterLogos();
      })
      .catch((err) => {
        this.backgroundsLoading = false;
        this.selectionError = true;
        this.selectionErrorMessage = this.extractErrorMessage(err);
      });
  }

  filterScreens() {
    const term = (this.screensSearchTerm || "").toLowerCase().trim();
    if (!term) {
      this.screensFiltered = this.backgroundsList.slice(0, this.screensDisplayLimit);
    } else {
      this.screensFiltered = this.backgroundsList
        .filter((item) => (item.name || "").toLowerCase().includes(term))
        .slice(0, this.screensDisplayLimit);
    }
    try {
      this.$scope.$applyAsync();
    } catch (e) {}
  }

  filterLogos() {
    const term = (this.logosSearchTerm || "").toLowerCase().trim();
    if (!term) {
      this.logosFiltered = this.backgroundsList.slice(0, this.logosDisplayLimit);
    } else {
      this.logosFiltered = this.backgroundsList
        .filter((item) => (item.name || "").toLowerCase().includes(term))
        .slice(0, this.logosDisplayLimit);
    }
    try {
      this.$scope.$applyAsync();
    } catch (e) {}
  }

  onScreensSearchChange() {
    if (this.screensDebounceTimer) {
      this.$timeout.cancel(this.screensDebounceTimer);
    }
    this.screensDebounceTimer = this.$timeout(() => {
      this.filterScreens();
    }, 300);
  }

  onLogosSearchChange() {
    if (this.logosDebounceTimer) {
      this.$timeout.cancel(this.logosDebounceTimer);
    }
    this.logosDebounceTimer = this.$timeout(() => {
      this.filterLogos();
    }, 300);
  }

  loadMoreScreens() {
    this.screensDisplayLimit += 50;
    this.filterScreens();
  }

  loadMoreLogos() {
    this.logosDisplayLimit += 50;
    this.filterLogos();
  }

  onScreenSelected(item) {
    this.selectedScreen = item;
    this.selection.screenId = item._id;
    this.selection.screenName = item.name;
    this.selection.desktopUrl = item.url && item.url[0] ? item.url[0] : null;
    this.selection.mobileUrl = item.iosUrl && item.iosUrl[0] ? item.iosUrl[0] : null;
    this.selection.desktopPreview = this.selection.desktopUrl;
    this.selection.mobilePreview = this.selection.mobileUrl;
    try {
      this.$scope.$applyAsync();
    } catch (e) {}
  }

  onLogoSelected(item) {
    this.selectedLogo = item;
    this.selection.logoId = item._id;
    this.selection.logoName = item.name;
    this.selection.logoDesktopUrl = item.url && item.url[0] ? item.url[0] : null;
    this.selection.logoMobileUrl = item.iosUrl && item.iosUrl[0] ? item.iosUrl[0] : null;
    this.selection.logoDesktopPreview = this.selection.logoDesktopUrl;
    this.selection.logoMobilePreview = this.selection.logoMobileUrl;
    try {
      this.$scope.$applyAsync();
    } catch (e) {}
  }

  // Toggle methods for custom select dropdowns
  toggleScreensDropdown() {
    this.screensDropdownOpen = !this.screensDropdownOpen;
    // Close the other dropdown
    if (this.screensDropdownOpen) {
      this.logosDropdownOpen = false;
    }
    try {
      this.$scope.$applyAsync();
    } catch (e) {}
  }

  toggleLogosDropdown() {
    this.logosDropdownOpen = !this.logosDropdownOpen;
    // Close the other dropdown
    if (this.logosDropdownOpen) {
      this.screensDropdownOpen = false;
    }
    try {
      this.$scope.$applyAsync();
    } catch (e) {}
  }

  // Select and close dropdown methods
  selectScreen(item) {
    this.onScreenSelected(item);
    this.screensDropdownOpen = false;
    try {
      this.$scope.$applyAsync();
    } catch (e) {}
  }

  selectLogo(item) {
    this.onLogoSelected(item);
    this.logosDropdownOpen = false;
    try {
      this.$scope.$applyAsync();
    } catch (e) {}
  }

  openPreviewModal(type) {
    if (type === 'screen') {
      this.previewTitle = 'Logo Screen Preview';
      this.previewDesktopUrl = this.selection.desktopUrl;
      this.previewMobileUrl = this.selection.mobileUrl;
    } else if (type === 'logo') {
      this.previewTitle = 'Login Screen Logo Preview';
      this.previewDesktopUrl = this.selection.logoDesktopUrl;
      this.previewMobileUrl = this.selection.logoMobileUrl;
    }
    this.showPreviewModal = true;
    try {
      this.$scope.$applyAsync();
    } catch (e) {}
  }

  closePreviewModal() {
    this.showPreviewModal = false;
    this.previewTitle = '';
    this.previewDesktopUrl = null;
    this.previewMobileUrl = null;
    try {
      this.$scope.$applyAsync();
    } catch (e) {}
  }

  hasMoreScreens() {
    const term = (this.screensSearchTerm || "").toLowerCase().trim();
    if (!term) {
      return this.backgroundsList.length > this.screensDisplayLimit;
    }
    const filtered = this.backgroundsList.filter((item) =>
      (item.name || "").toLowerCase().includes(term)
    );
    return filtered.length > this.screensDisplayLimit;
  }

  hasMoreLogos() {
    const term = (this.logosSearchTerm || "").toLowerCase().trim();
    if (!term) {
      return this.backgroundsList.length > this.logosDisplayLimit;
    }
    const filtered = this.backgroundsList.filter((item) =>
      (item.name || "").toLowerCase().includes(term)
    );
    return filtered.length > this.logosDisplayLimit;
  }

  initBackgrounds() {
    // This is called from ng-init in template but we now handle it in getCompany
    // Keep as fallback in case template calls it before getCompany completes
    if (!this.backgroundsLoaded && !this.backgroundsLoading && this.company) {
      this.loadBackgroundsList();
    }
  }

  prefillSelectionsFromCompany() {
    // Pre-fill selection from existing company brands
    try {
      const brands = this.company && this.company.brands;
      if (brands && Array.isArray(brands) && brands.length) {
        const b = brands[0];
        if (b.screens && b.screens.length) {
          const s = b.screens[0];
          this.selection.screenId = s.screenId || s._id;
          this.selection.screenName = s.name || null;
          this.selection.desktopUrl = s.url;
          this.selection.mobileUrl = s.iosUrl;
          this.selection.desktopPreview = s.url;
          this.selection.mobilePreview = s.iosUrl;
        }
        if (b.logos && b.logos.length) {
          const l = b.logos[0];
          this.selection.logoId = l.logoId || l._id;
          this.selection.logoName = l.name || null;
          this.selection.logoDesktopUrl = l.url;
          this.selection.logoMobileUrl = l.iosUrl;
          this.selection.logoDesktopPreview = l.url;
          this.selection.logoMobilePreview = l.iosUrl;
        }
      }
    } catch (e) {
      // ignore errors while pre-filling
    }
  }

  clearScreenSelection() {
    if (!this.selection.screenId || !this.selection.screenName) return;
    
    // Call the existing deleteBackground method
    this.deleteBackground(this.selection.screenId, this.selection.screenName);
    
    // Clear local state
    this.selectedScreen = null;
    this.selection.screenId = null;
    this.selection.screenName = null;
    this.selection.desktopUrl = null;
    this.selection.mobileUrl = null;
    this.selection.desktopPreview = null;
    this.selection.mobilePreview = null;
    
    try {
      this.$scope.$applyAsync();
    } catch (e) {}
  }

  clearLogoSelection() {
    if (!this.selection.logoId || !this.selection.logoName) return;
    
    // Call the existing deleteBackground method
    this.deleteBackground(this.selection.logoId, this.selection.logoName);
    
    // Clear local state
    this.selectedLogo = null;
    this.selection.logoId = null;
    this.selection.logoName = null;
    this.selection.logoDesktopUrl = null;
    this.selection.logoMobileUrl = null;
    this.selection.logoDesktopPreview = null;
    this.selection.logoMobilePreview = null;
    
    try {
      this.$scope.$applyAsync();
    } catch (e) {}
  }

  // Clear selection and close dropdown (for "None" option - doesn't call delete API)
  clearScreenSelectionAndClose() {
    this.selectedScreen = null;
    this.selection.screenId = null;
    this.selection.screenName = null;
    this.selection.desktopUrl = null;
    this.selection.mobileUrl = null;
    this.selection.desktopPreview = null;
    this.selection.mobilePreview = null;
    this.screensDropdownOpen = false;
    try {
      this.$scope.$applyAsync();
    } catch (e) {}
  }

  clearLogoSelectionAndClose() {
    this.selectedLogo = null;
    this.selection.logoId = null;
    this.selection.logoName = null;
    this.selection.logoDesktopUrl = null;
    this.selection.logoMobileUrl = null;
    this.selection.logoDesktopPreview = null;
    this.selection.logoMobilePreview = null;
    this.logosDropdownOpen = false;
    try {
      this.$scope.$applyAsync();
    } catch (e) {}
  }

  openImageModal() {
    this.showImageModal = true;
    this.modal = {
      name: "",
      desktopFile: null,
      mobileFile: null,
      logoDesktopFile: null,
      logoMobileFile: null,
      desktopPreview: null,
      mobilePreview: null,
      logoDesktopPreview: null,
      logoMobilePreview: null,
      desktopUploadedUrl: null,
      mobileUploadedUrl: null,
      logoDesktopUploadedUrl: null,
      logoMobileUploadedUrl: null,
      screenId: null,
      logoId: null,
      screenName: null,
      logoName: null,
      saving: false,
      error: false,
      success: false,
      uploadingDesktop: false,
      uploadingMobile: false,
      uploadingLogoDesktop: false,
      uploadingLogoMobile: false,
      errorMessage: null,
    };

    const pickUrl = (val) => {
      return val;
    };

    // if company has brands saved already, populate modal
    try {
      const brands = this.company && this.company.brands;
      if (brands && Array.isArray(brands) && brands.length) {
        const b = brands[0];
        if (b.screens && b.screens.length) {
          const s = b.screens[0];
          this.modal.screenId = s._id;
          this.modal.screenName = s.name || null;

          this.modal.desktopUploadedUrl = pickUrl(s.url);
          this.modal.mobileUploadedUrl = pickUrl(s.iosUrl);

          this.modal.desktopPreview = this.modal.desktopUploadedUrl;
          this.modal.mobilePreview = this.modal.mobileUploadedUrl;
        }
        if (b.logos && b.logos.length) {
          const l = b.logos[0];
          this.modal.logoId = l.logoId || l._id || l.logo_id || null;
          this.modal.logoName = l.name || null;
          this.modal.logoDesktopUploadedUrl = pickUrl(l.url);
          this.modal.logoMobileUploadedUrl = pickUrl(l.iosUrl);
          this.modal.logoDesktopPreview = this.modal.logoDesktopUploadedUrl;
          this.modal.logoMobilePreview = this.modal.logoMobileUploadedUrl;
        }
      }
    } catch (e) {
      // ignore errors while pre-filling
    }

    // Reset dropdown state
    this.screensSearchTerm = "";
    this.logosSearchTerm = "";
    this.screensDisplayLimit = 50;
    this.logosDisplayLimit = 50;
    this.selectedScreen = null;
    this.selectedLogo = null;

    // Load backgrounds list
    this.loadBackgroundsList();
  }

  onDesktopSelected(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    this.modal.desktopFile = file;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.modal.desktopPreview = e.target.result;
      try {
        this.$scope.$applyAsync();
      } catch (e) {}
    };
    reader.readAsDataURL(file);

    this.modal.uploadingDesktop = true;
    const fd = new FormData();
    fd.append("background", file);
    const reqConfigUpload = requestConfigV2(
      "ADD",
      fd,
      "backgrounds/image/upload",
      2
    );

    reqConfigUpload.headers = reqConfigUpload.headers || {};
    reqConfigUpload.headers["Content-Type"] = undefined;

    reqConfigUpload.headers["api-key"] = "MYLcvDAg5175KH5vTvGtvanxLtFNr8yU";
    reqConfigUpload.transformRequest = angular.identity;

    this.$http(reqConfigUpload)
      .then((resp) => {
        this.modal.desktopUploadedUrl = resp.data[0];
        this.modal.uploadingDesktop = false;
      })
      .catch((err) => {
        this.modal.uploadingDesktop = false;
        this.modal.error = true;
        this.modal.errorMessage = this.extractErrorMessage(err);
      });
  }

  onMobileSelected(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    this.modal.mobileFile = file;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.modal.mobilePreview = e.target.result;
      try {
        this.$scope.$applyAsync();
      } catch (e) {}
    };
    reader.readAsDataURL(file);

    this.modal.uploadingMobile = true;
    const fd = new FormData();
    fd.append("background", file);
    const reqConfigUploadMobile = requestConfigV2(
      "ADD",
      fd,
      "backgrounds/image/upload",
      2
    );
    reqConfigUploadMobile.headers = reqConfigUploadMobile.headers || {};
    reqConfigUploadMobile.headers["Content-Type"] = undefined;

    reqConfigUploadMobile.headers["api-key"] =
      "MYLcvDAg5175KH5vTvGtvanxLtFNr8yU";
    reqConfigUploadMobile.transformRequest = angular.identity;

    this.$http(reqConfigUploadMobile)
      .then((resp) => {
        this.modal.mobileUploadedUrl = resp.data[0];
        this.modal.uploadingMobile = false;
      })
      .catch((err) => {
        this.modal.uploadingMobile = false;
        this.modal.error = true;
        this.modal.errorMessage = this.extractErrorMessage(err);
      });
  }

  onLogoDesktopSelected(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    this.modal.logoDesktopFile = file;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.modal.logoDesktopPreview = e.target.result;
      try {
        this.$scope.$applyAsync();
      } catch (e) {}
    };
    reader.readAsDataURL(file);

    this.modal.uploadingLogoDesktop = true;
    const fd = new FormData();
    fd.append("background", file);
    const req = requestConfigV2("ADD", fd, "backgrounds/image/upload", 2);
    req.headers = req.headers || {};
    req.headers["Content-Type"] = undefined;
    req.headers["api-key"] =
      req.headers["api-key"] || "MYLcvDAg5175KH5vTvGtvanxLtFNr8yU";
    req.transformRequest = angular.identity;
    this.$http(req)
      .then((resp) => {
        this.modal.logoDesktopUploadedUrl = resp.data[0];
        this.modal.uploadingLogoDesktop = false;
      })
      .catch((err) => {
        this.modal.uploadingLogoDesktop = false;
        this.modal.error = true;
        this.modal.errorMessage = this.extractErrorMessage(err);
      });
  }

  onLogoMobileSelected(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    this.modal.logoMobileFile = file;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.modal.logoMobilePreview = e.target.result;
      try {
        this.$scope.$applyAsync();
      } catch (e) {}
    };
    reader.readAsDataURL(file);

    this.modal.uploadingLogoMobile = true;
    const fd = new FormData();
    fd.append("background", file);
    const req = requestConfigV2("ADD", fd, "backgrounds/image/upload", 2);
    req.headers = req.headers || {};
    req.headers["Content-Type"] = undefined;
    req.headers["api-key"] =
      req.headers["api-key"] || "MYLcvDAg5175KH5vTvGtvanxLtFNr8yU";
    req.transformRequest = angular.identity;
    this.$http(req)
      .then((resp) => {
        this.modal.logoMobileUploadedUrl = resp.data[0];
        this.modal.uploadingLogoMobile = false;
      })
      .catch((err) => {
        this.modal.uploadingLogoMobile = false;
        this.modal.error = true;
        this.modal.errorMessage = this.extractErrorMessage(err);
      });
  }

  cancelModal() {
    this.showImageModal = false;
    this.modal = null;
  }

  commit() {
    if (
      !this.modal ||
      !this.modal.screenName ||
      !this.modal.logoName ||
      !this.modal.desktopUploadedUrl ||
      !this.modal.mobileUploadedUrl ||
      !this.modal.logoDesktopUploadedUrl ||
      !this.modal.logoMobileUploadedUrl
    )
      return;
    this.modal.saving = true;
    this.modal.error = false;

    // Since we're selecting from existing backgrounds, we just need to update the company brands
    const screenId = this.modal.screenId;
    const logoId = this.modal.logoId;

    const brandsPayload = {
      _id: this.company._id,
      brands: [
        {
          screens: [
            {
              screenId: screenId,
              name: this.modal.screenName,
              url: this.modal.desktopUploadedUrl,
              iosUrl: this.modal.mobileUploadedUrl,
            },
          ],
          logos: [
            {
              logoId: logoId,
              name: this.modal.logoName,
              url: this.modal.logoDesktopUploadedUrl,
              iosUrl: this.modal.logoMobileUploadedUrl,
            },
          ],
        },
      ],
    };

    const reqUpdate = requestConfigV2(
      "EDIT",
      brandsPayload,
      "companies/edit",
      2
    );

    const updatedCompany = {
      ...this.company,
      brands: brandsPayload.brands,
    };

    this.updateCompany(updatedCompany)
      .then(() => {
        this.success = true;
        this.getCompany();

        this.$http(reqUpdate)
          .then((compData) => {
            console.log("Updated in v2", compData);
          })
          .catch((err) => {
            console.warn("v2 companies/edit failed", err);
          });

        this.modal.success = true;
        this.modal.saving = false;
        this.showImageModal = false;
        this.modal = null;
      })
      .catch((err) => {
        this.modal.error = true;
        this.modal.errorMessage = this.extractErrorMessage(err);
        this.modal.saving = false;
      });
  }

  deleteBackground(id, name) {
    if (!id || !name) return;
    //if (!confirm("Are you sure you want to delete this background?")) return;

    // Initialize modal if not exists (for inline UI calls)
    if (!this.modal) {
      this.modal = { saving: false, deleting: false, error: false };
    }
    
    this.modal.saving = true;
    this.modal.deleting = true;
    this.modal.error = false;

    const reqConfig = requestConfigV2(
      "DELETE",
      { _id: id, name: name },
      "backgrounds",
      2
    );

    this.$http(reqConfig)
      .then(() => {
        // Update local company brands
        const brands = this.company.brands || [];
        let payloadBrands = [];

        if (brands.length > 0) {
          const brand = brands[0];
          if (brand.screens) {
            brand.screens = brand.screens.filter(
              (s) => s.screenId !== id && s._id !== id
            );
          }
          if (brand.logos) {
            brand.logos = brand.logos.filter(
              (l) => l.logoId !== id && l._id !== id
            );
          }
          brands[0] = brand;

          // Construct clean payload brand
          const payloadBrand = {};
          if (brand.screens && brand.screens.length > 0) {
            payloadBrand.screens = brand.screens.map((s) => ({
              screenId: s.screenId,
              name: s.name,
              url: s.url,
              iosUrl: s.iosUrl,
            }));
          }
          if (brand.logos && brand.logos.length > 0) {
            payloadBrand.logos = brand.logos.map((l) => ({
              logoId: l.logoId,
              name: l.name,
              url: l.url,
              iosUrl: l.iosUrl,
            }));
          }
          payloadBrands.push(payloadBrand);
        }

        const brandsPayload = {
          _id: this.company._id,
          brands: payloadBrands,
        };

        const reqUpdate = requestConfigV2(
          "EDIT",
          brandsPayload,
          "companies/edit",
          2
        );

        const updatedCompany = {
          ...this.company,
          brands: brands,
        };

        this.updateCompany(updatedCompany)
          .then(() => {
            this.$http(reqUpdate)
              .then((compData) => {
                console.log("Updated in v2", compData);
              })
              .catch((err) => {
                console.warn("v2 companies/edit failed", err);
              });

            if (this.modal) {
              this.modal.success = true;
              this.modal.saving = false;
              this.modal.deleting = false;
            }
            this.showImageModal = false;
            this.modal = null;
            this.getCompany();
            // Refetch the backgrounds list
            this.backgroundsLoaded = false;
            this.loadBackgroundsList();
          })
          .catch((err) => {
            if (this.modal) {
              this.modal.error = true;
              this.modal.errorMessage = this.extractErrorMessage(err);
              this.modal.saving = false;
              this.modal.deleting = false;
            }
          });
      })
      .catch((err) => {
        if (this.modal) {
          this.modal.error = true;
          this.modal.errorMessage = this.extractErrorMessage(err);
          this.modal.saving = false;
          this.modal.deleting = false;
        }
      });
  }
}

export default angular
  .module("leafApp.companygenie", [uiRouter])
  .config(routes)
  .component("companygenie", {
    template: require("./companygenie.html").default,
    controller: CompanyGenieComponent,
    controllerAs: "companygenieCtrl",
  }).name;
